import {usePlantConfig} from '@domain/shifthandover'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {STOPPAGE_ANALYSIS_SUB_PATH, stoppageAnalysisSubRoute} from '@features/stoppage-analysis'
import {DateRange} from '@hconnect/common'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {toTimeRange} from '@hconnect/common/utils'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {buildFeatureUrl, usePlantIdFromHierarchyId, useSuiteHierarchyId} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import {generatePath, RouteObject, useNavigate} from 'react-router'

import {shiftSummaryFeatureTranslations} from '../localization'
import {ShiftSummaryPage} from '../pages'

const SuiteShiftSummaryPage = () => {
  const plantId = usePlantIdFromHierarchyId()
  const hierarchyId = useSuiteHierarchyId()
  const {
    i18n: {language}
  } = useTranslation()
  const {data: config} = usePlantConfig({plantId: plantId ?? '', language})
  const navigate = useNavigate()

  const handleEquipmentClick = useCallback(
    (equipmentId: string, dateRange: DateRange) => {
      const equipmentUrl = generatePath(STOPPAGE_ANALYSIS_SUB_PATH, {equipmentId})
      const timeRange = toTimeRange([dateRange.startDate, dateRange.endDate])
      const rangeParams = encodeURIComponent(`[${timeRange.startDate},${timeRange.endDate}]`)
      const searchParams = `timeRange=${rangeParams}&referrer=shiftSummary`

      void navigate(`${equipmentUrl}?${searchParams}`)
    },
    [navigate]
  )

  if (!plantId || !config) {
    return <CircularProgress />
  }

  return (
    <ShiftSummaryPage
      plantId={plantId}
      dashboardUrl={buildFeatureUrl('DowntimeDashboard', hierarchyId)}
      onEquipmentClick={handleEquipmentClick}
    />
  )
}

const ShiftSummaryRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={shiftSummaryFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <SuiteShiftSummaryPage />
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const shiftSummaryRoutes: RouteObject = {
  path: '*',
  children: [
    {
      index: true,
      element: <ShiftSummaryRouteWrapper />
    },
    stoppageAnalysisSubRoute
  ]
}
